import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import { store } from 'redux-rest-reducer';

import { Button, Separator, Text } from '@cuemath/comps';

import { post as bulkAssignRM } from 'actions/bulk-parent-rm-assignment';
import { patch as bulkRMUpdate } from 'actions/relationship-manager';
import { closeModal } from 'actions/modal';
import { ButtonWrapper, Field, Head, Message } from 'modules/form';

const AnchorLink = styled.a`
  text-align: left;
  display: block;
  text-decoration: underline;
  color: blue;
  &:hover {
    color: blue;
  }
`;
const FormWrapper = styled.div`
  padding-left: 20px;
  text-align: center;
`;
const HeadWrapper = styled(Head)`
  border-bottom: 1px solid #333;
`;

class BulkRMAssignmentModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      bulkRMAssignment: store.post(),
      bulkRMDetailsUpdate: store.patch(),
      errorText: null,
      message: null,
    };
  }

  static getDerivedStateFromProps(
    { parentRMAssignment, parentRM, actions, data, modalType, postUpload = () => {} },
    { bulkRMAssignment, bulkRMDetailsUpdate },
  ) {
    if (modalType === 'rm_assignment') {
      const parentRMAssignmentPost = store.post(parentRMAssignment, bulkRMAssignment.id);
      const newState = {};
      if (parentRMAssignmentPost.resolved) {
        if (parentRMAssignmentPost.resolved.isCreated) {
          newState.message = 'RM Assignment Sheet Uploaded Successfully';
          postUpload('success');
          actions.closeModal();
        } else if (parentRMAssignmentPost.resolved.isCreatingFailed) {
          const errorObj = store.getError(parentRMAssignmentPost.resolved);
          newState.errorText = errorObj ? errorObj.message : 'Something went wrong';
        }
      }
      return newState;
    } else if (modalType === 'bulk_rm_update') {
      const parentRMPatch = store.patch(parentRM, bulkRMDetailsUpdate.id);
      const newState = {};
      if (parentRMPatch.resolved) {
        if (parentRMPatch.resolved.isPatched) {
          newState.message = 'RM Assignment Sheet Uploaded Successfully';
          postUpload('success');
          actions.closeModal();
        } else if (parentRMPatch.resolved.isPatchingFailed) {
          const errorObj = store.getError(parentRMPatch.resolved);
          newState.errorText = errorObj ? errorObj.message : 'Something went wrong';
        }
      }
      return newState;
    }
  }

  onSubmit = event => {
    event.preventDefault();
    const { modalType, actions } = this.props;
    const { bulkRMAssignment, bulkRMDetailsUpdate, file: fileToUpload } = this.state;
    const formData = new FormData();
    formData.append('file', fileToUpload);

    if (modalType === 'rm_assignment') {
      actions.bulkAssignRM(bulkRMAssignment.id, formData);
    } else if (modalType === 'bulk_rm_update') {
      actions.bulkRMUpdate(bulkRMDetailsUpdate.id, 'null', formData);
    }
  };

  onChange = e => {
    this.setState({
      file: e.target.files[0],
    });
  };

  render() {
    const { errorText, message } = this.state;
    let instructionText;
    let instructionFile;
    if (this.props.modalType === 'rm_assignment') {
      instructionText = 'Format(CSV): student_id*, rm_email*';
      instructionFile =
        'https://docs.google.com/spreadsheets/d/1ICHRqJMxWmiriygW40lvNY_afgrV4KDMCSNJ3t-xsOE/edit';
    } else if (this.props.modalType === 'bulk_rm_update') {
      instructionText = 'Format(CSV): rm_email*, weight*, state*';
      instructionFile =
        'https://docs.google.com/spreadsheets/d/16RnD8AR2giLCnalpmR8_cA1cSZ3xtumfqxu6K4q3lco/edit?usp=sharing';
    }

    return (
      <form onSubmit={this.onSubmit}>
        <HeadWrapper>
          <Text size="xlarge" align="center">
            Upload File
          </Text>
        </HeadWrapper>
        <FormWrapper>
          {message && <Message>{message}</Message>}
          {errorText && <Message error>{errorText}</Message>}
          <Separator transparent height="25" />
          <Field key="fileUpload">
            <input
              name="fileUpload"
              placeholder="Upload File"
              type="file"
              onChange={this.onChange}
              required={true}
            />
          </Field>
          <Separator height={15} transparent />
          <Text>{instructionText}</Text>
          <AnchorLink href={instructionFile} target="_blank">
            Instructions
          </AnchorLink>
          <Separator height={15} transparent />
          <Header floated="left">
            <ButtonWrapper flexDirection="row-reverse">
              <Button label="Submit" />
            </ButtonWrapper>
          </Header>
          <Separator transparent height="10" />
        </FormWrapper>
      </form>
    );
  }
}

export default connect(
  ({ parentRMAssignment, parentRM }) => ({ parentRMAssignment, parentRM }),
  dispatch => ({
    actions: bindActionCreators(
      {
        bulkAssignRM,
        bulkRMUpdate,
        closeModal,
      },
      dispatch,
    ),
  }),
)(BulkRMAssignmentModal);
